import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../theme/ThemeContext';
import { isSameDay } from '../utils';

interface PhoneDayHeaderProps {
  days: Date[];
  gutterWidth: number;
  nowTick: number;
  onDayClick?: (day: Date) => void;
}

/** Google-style column header: small weekday above the day number, today circled. */
export const PhoneDayHeader: React.FC<PhoneDayHeaderProps> = ({ days, gutterWidth, nowTick, onDayClick }) => {
  const { i18n } = useTranslation();
  const { tokens } = useTheme();
  const today = new Date(nowTick);

  return (
    <div className="phone-cal-day-header" style={{ background: tokens.calendar.panel, borderBottom: `1px solid ${tokens.calendar.divider}` }}>
      <div style={{ width: gutterWidth, flexShrink: 0 }} />
      {days.map(day => {
        const isToday = isSameDay(day, today);
        const content = (
          <>
            <span className="phone-cal-weekday" style={{ color: isToday ? tokens.app.primary : tokens.calendar.muted }}>
              {day.toLocaleDateString(i18n.language, { weekday: 'short' }).replace('.', '')}
            </span>
            <span
              className="phone-cal-daynum"
              style={isToday
                ? { background: tokens.app.primary, color: tokens.app.primaryText }
                : { color: tokens.calendar.text }}
            >
              {day.getDate()}
            </span>
          </>
        );
        return onDayClick ? (
          <button key={day.toDateString()} type="button" className="phone-cal-day-cell" onClick={() => onDayClick(day)}>
            {content}
          </button>
        ) : (
          <div key={day.toDateString()} className="phone-cal-day-cell">{content}</div>
        );
      })}
      <div id="calendarScrollbarSpacer" style={{ width: 0, flexShrink: 0 }} />
    </div>
  );
};
